import React from 'react'
import classnames from 'classnames'
import { Modal } from 'antd'

const FOModal = ({
  visible,
  setVisible,
  children,
  className,
  center,
  style,
  bodyStyle,
  getContainer,
  width,
}) => {
  return (
    <Modal
      title={null}
      footer={null}
      closable={false}
      visible={visible}
      className={classnames('common-modal', className)}
      centered={center}
      maskTransitionName=''
      transitionName=''
      style={style}
      bodyStyle={bodyStyle}
      getContainer={getContainer}
      width={width}
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </Modal>
  )
}

export default FOModal
